/**
 * SliderList component.
 */
import Container from '@components/atoms/container/sliderContainer';
import CircularList from '@components/sections/list/circularList/circularList';
import { CircularListProps } from '../circularList/useCircularList';
import { DELAY, DURATION } from '@shared/types/constants/animations';

/**
 * Displays the slider list.
 * @returns {JSX.Element} The SliderList component.
 */
export default function SliderList<T>(props: CircularListProps<T>) {
  return (
    <Container
      display={!!props.items?.length}
      duration={DURATION.SLIDER_LIST_CONTAINER}
      delay={DELAY.SLIDER_LIST_CONTAINER}
    >
      <CircularList {...props} />
    </Container>
  );
}
